import { render, staticRenderFns } from "./MailServiceTrigger.vue?vue&type=template&id=31fad5f1&"
import script from "./MailServiceTrigger.vue?vue&type=script&lang=js&"
export * from "./MailServiceTrigger.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports